import collections from 'rlink-collections/collections';

import average from './average.js';
import constructsUsing from './constructsUsing.js';
import copyGenerator from './copyGenerator.js';
import count from './count.js';
import deepCopy from './deepCopy.js';
import deepEquals from './deepEquals.js';
import entries from './entries.js';
import getAt from './getAt.js';
import groupBy from './groupBy.js';
import hasKey from './hasKey.js';
import isCollection from './isCollection.js';
import isIterable from './isIterable.js';
import iterate from './iterate.js';
import keys from './keys.js';
import makeShapeTemplate from './makeShapeTemplate.js';
import setAt from './setAt.js';
import sum from './sum.js';
import updateAt from './updateAt.js';
import valueCopy from './valueCopy.js';
import valueEquals from './valueEquals.js';
import valueForKey from './valueForKey.js';
import valueGetters from './valueGetters.js';
import values from './values.js';
import yieldableFor from './yieldableFor.js';


export default collections({
  average,
  constructsUsing,
  copyGenerator,
  count,
  deepCopy,
  deepEquals,
  entries,
  getAt,
  groupBy,
  hasKey,
  isCollection,
  isIterable,
  iterate,
  keys,
  makeShapeTemplate,
  setAt,
  sum,
  updateAt,
  valueCopy,
  valueEquals,
  valueForKey,
  valueGetters,
  values,
  yieldableFor,
});



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/index.js